import React from 'react';
import { kebabCase } from 'lodash';
import { Stack } from '@hub/stack';
import { LinkSection } from './link-section';
import { CentreDetails } from './centre-details';
import * as paths from './paths';
import { trackUniversalFooterLinkClick } from './analytics';
import { LeftColumnLinks } from './left-column-links';
import useFeatureFlag from '../../hooks/use-feature-flag';
import { FeatureFlagName } from '../../feature-flags';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const customerSupport = {
  text: 'Customer Support',
  url: paths.CUSTOMER_SUPPORT
};
const LeftColumnContainerFlexGrowDesktop = 3;
export const LeftColumnContainer = _ref => {
  let {
    centre,
    country,
    onFindACentre
  } = _ref;
  const isOnlineDecommissionMode = useFeatureFlag(FeatureFlagName.NEXT_PUBLIC_FEAT_FLAG_ONLINE_DECOMMISSION);
  return /*#__PURE__*/_jsxs(Stack, {
    direction: ['column', 'column', 'column', 'row'],
    shouldWrapChildren: false,
    gap: ['spacing-xl', 'spacing-xl', 'spacing-xl', '0'],
    sx: {
      flexGrow: [1, 1, 1, LeftColumnContainerFlexGrowDesktop]
    },
    flexGrow: 0,
    "data-id": "universal-footer_left-column-container_LeftColumnContainer_Stack",
    children: [/*#__PURE__*/_jsxs(Stack, {
      as: "nav",
      "aria-label": "Footer Links",
      shouldWrapChildren: false,
      gap: "spacing-xl",
      sx: {
        flexGrow: 1,
        paddingRight: 'spacing-xl',
        marginRight: 'spacing-2xl'
      },
      "data-id": "universal-footer_left-column-container_LeftColumnContainer_Stack_Stack_1",
      children: [centre ? /*#__PURE__*/_jsx(CentreDetails, {
        centre: centre,
        onFindACentre: onFindACentre,
        "data-id": "universal-footer_left-column-container_LeftColumnContainer_CentreDetails"
      }) : onFindACentre && /*#__PURE__*/_jsx(LinkSection, {
        heading: {
          text: 'Find a centre',
          onClick: onFindACentre
        },
        trackers: {
          clicked: trackUniversalFooterLinkClick
        },
        "data-id": "universal-footer_left-column-container_LeftColumnContainer_LinkSection"
      }), country === 'Australia' && /*#__PURE__*/_jsx(LinkSection, {
        heading: customerSupport,
        trackers: {
          clicked: trackUniversalFooterLinkClick
        },
        "aria-labelledby": kebabCase(customerSupport.text),
        "data-id": "universal-footer_left-column-container_LeftColumnContainer_LinkSection_4"
      })]
    }), country === 'Australia' && /*#__PURE__*/_jsx(LeftColumnLinks, {
      isOnlineDecommissionMode: isOnlineDecommissionMode,
      "data-id": "universal-footer_left-column-container_LeftColumnContainer_LeftColumnLinks"
    })]
  });
};